<div class="product-container">
  <!-- Left: Image section -->
  <div class="image-section">
    <div class="shimmer image-placeholder"></div>
    <div class="thumbnails">
      <div class="shimmer thumbnail"></div>
      <div class="shimmer thumbnail"></div>
      <div class="shimmer thumbnail"></div>
      <div class="shimmer thumbnail"></div>
      <div class="shimmer thumbnail"></div>
    </div>
  </div>

  <!-- Right: Details section -->
  <div class="details-section">
    <div class="shimmer title"></div>
    <div class="shimmer price"></div>
    <div class="shimmer mrp"></div>

    <div class="color-options">
      <div class="shimmer color-square"></div>
      <div class="shimmer color-square"></div>
      <div class="shimmer color-square"></div>
      <div class="shimmer color-square"></div>
      <div class="shimmer color-square"></div>
    </div>

    <div class="shimmer offer"></div>

    <div class="buttons">
      <div class="shimmer button"></div>
      <div class="shimmer button"></div>
    </div>
  </div>
</div>
